import React from 'react';
import Icon from '../../../components/AppIcon';

const QuickStatsBar = ({ stats }) => {
  const statItems = [
    {
      icon: 'Briefcase',
      label: 'Beschikbare opdrachten',
      value: stats?.availableJobs,
      color: 'text-primary'
    },
    {
      icon: 'TrendingUp',
      label: 'Gemiddeld tarief',
      value: `€${stats?.averageRate?.toFixed(2)}/uur`,
      color: 'text-success'
    },
    {
      icon: 'MapPin',
      label: 'In jouw regio',
      value: stats?.nearbyJobs,
      color: 'text-accent'
    },
    {
      icon: 'Clock',
      label: 'Nieuwe vandaag',
      value: stats?.newToday,
      color: 'text-warning'
    }
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
      {statItems?.map((item, index) => (
        <div
          key={index}
          className="bg-card border border-border rounded-lg p-3 md:p-4 hover:elevation-sm transition-smooth"
        >
          <div className="flex items-center gap-2.5 mb-2">
            <div className={`w-8 h-8 md:w-10 md:h-10 bg-${item?.color?.replace('text-', '')}/10 rounded-lg flex items-center justify-center flex-shrink-0`}>
              <Icon name={item?.icon} size={18} color={`var(--color-${item?.color?.replace('text-', '')})`} />
            </div>
            <span className="caption text-muted-foreground line-clamp-1">
              {item?.label}
            </span>
          </div>
          <p className="font-heading font-semibold text-xl md:text-2xl text-foreground">
            {item?.value}
          </p>
        </div>
      ))}
    </div>
  );
};

export default QuickStatsBar;